import {converter, Operation} from "./Operation";
import {CellContent} from "./CellContent";
import {ContentHeader} from "./ContentHeader";
import {SerializableJourneyMap} from "./SerializableJourneyMap";
import {Funnel} from "./Funnel";
import {RoleHeader} from "./RoleHeader";
import {ContentKey, ContentKeyPair, FunnelKey, RoleKey} from "./Keys";

export type OpType =
    "UpdateJourneyMap" |
    "UpdateTitle" |
    "UpdateBackground" |
    "UpdateColorScheme" |
    "AppendFunnel" |
    "RemoveFunnel" |
    "MoveFunnel" |
    "SetFunnelName" |
    "SetFunnelSize" |
    "SetFunnelIsHidden" |
    "SetFunnelGroupName" |
    "AppendContent" |
    "RemoveContent" |
    "MoveContent" |
    "SetContentName" |
    "SetContentSize" |
    "SetContentIsHidden" |
    "UpdateCellContent" |
    "ResizeCell" |
    "AppendRole" |
    "RemoveRole" |
    "MoveRole" |
    "SetRoleName" |
    "SetRoleCellName" |
    "SetShowPersona" |
    "SetPersonaImage" |
    "SetPersonaTagline" |
    "SetPersonaSpecName" |
    "SetPersonaSpecValue" |
    "SetPersonaDescription";

export function OpTypeToObject(op_type: string, data: any): Operation {
    if (op_type === "UpdateJourneyMap") {
        return OpUpdateJourneyMap.fromJSON(data);
    } else if (op_type === "UpdateTitle") {
        return OpUpdateTitle.fromJSON(data);
    } else if (op_type === "UpdateBackground") {
        return OpUpdateBackground.fromJSON(data);
    } else if (op_type === "UpdateColorScheme") {
        return OpUpdateColorScheme.fromJSON(data);
    } else if (op_type === "AppendFunnel") {
        return OpAppendFunnel.fromJSON(data);
    } else if (op_type === "RemoveFunnel") {
        return OpRemoveFunnel.fromJSON(data);
    } else if (op_type === "MoveFunnel") {
        return OpMoveFunnel.fromJSON(data);
    } else if (op_type === "SetFunnelName") {
        return OpSetFunnelName.fromJSON(data);
    } else if (op_type === "SetFunnelSize") {
        return OpSetFunnelSize.fromJSON(data);
    } else if (op_type === "SetFunnelIsHidden") {
        return OpSetFunnelIsHidden.fromJSON(data);
    } else if (op_type === "SetFunnelGroupName") {
        return OpSetFunnelGroupName.fromJSON(data);
    } else if (op_type === "AppendContent") {
        return OpAppendContent.fromJSON(data);
    } else if (op_type === "RemoveContent") {
        return OpRemoveContent.fromJSON(data);
    } else if (op_type === "MoveContent") {
        return OpMoveContent.fromJSON(data);
    } else if (op_type === "SetContentName") {
        return OpSetContentName.fromJSON(data);
    } else if (op_type === "SetContentSize") {
        return OpSetContentSize.fromJSON(data);
    } else if (op_type === "SetContentIsHidden") {
        return OpSetContentIsHidden.fromJSON(data);
    } else if (op_type === "UpdateCellContent") {
        return OpUpdateCellContent.fromJSON(data);
    } else if (op_type === "ResizeCell") {
        return OpResizeCell.fromJSON(data);
    } else if (op_type === "AppendRole") {
        return OpAppendRole.fromJSON(data);
    } else if (op_type === "RemoveRole") {
        return OpRemoveRole.fromJSON(data);
    } else if (op_type === "MoveRole") {
        return OpMoveRole.fromJSON(data);
    } else if (op_type === "SetRoleName") {
        return OpSetRoleName.fromJSON(data);
    } else if (op_type === "SetRoleCellName") {
        return OpSetRoleCellName.fromJSON(data);
    } else if (op_type === "SetShowPersona") {
        return OpSetShowPersona.fromJSON(data);
    } else if (op_type === "SetPersonaImage") {
        return OpSetPersonaImage.fromJSON(data);
    } else if (op_type === "SetPersonaTagline") {
        return OpSetPersonaTagline.fromJSON(data);
    } else if (op_type === "SetPersonaSpecName") {
        return OpSetPersonaSpecName.fromJSON(data);
    } else if (op_type === "SetPersonaSpecValue") {
        return OpSetPersonaSpecValue.fromJSON(data);
    } else if (op_type === "SetPersonaDescription") {
        return OpSetPersonaDescription.fromJSON(data);
    }


    throw new Error("invalid op_type as OpType");
}

export function isTypeUpdateJourneyMap(op: Operation): op is OpUpdateJourneyMap {
    return op.type === "UpdateJourneyMap";
}

export function isTypeUpdateTitle(op: Operation): op is OpUpdateTitle {
    return op.type === "UpdateTitle";
}

export function isTypeUpdateBackground(op: Operation): op is OpUpdateBackground {
    return op.type === "UpdateBackground";
}

export function isTypeUpdateColorScheme(op: Operation): op is OpUpdateColorScheme {
    return op.type === "UpdateColorScheme";
}

export function isTypeAppendFunnel(op: Operation): op is OpAppendFunnel {
    return op.type === "AppendFunnel";
}

export function isTypeRemoveFunnel(op: Operation): op is OpRemoveFunnel {
    return op.type === "RemoveFunnel";
}

export function isTypeMoveFunnel(op: Operation): op is OpMoveFunnel {
    return op.type === "MoveFunnel";
}

export function isTypeSetFunnelName(op: Operation): op is OpSetFunnelName {
    return op.type === "SetFunnelName";
}

export function isTypeSetFunnelSize(op: Operation): op is OpSetFunnelSize {
    return op.type === "SetFunnelSize";
}

export function isTypeSetFunnelIsHidden(op: Operation): op is OpSetFunnelIsHidden {
    return op.type === "SetFunnelIsHidden";
}

export function isTypeSetFunnelGroupName(op: Operation): op is OpSetFunnelGroupName {
    return op.type === "SetFunnelGroupName";
}

export function isTypeAppendContent(op: Operation): op is OpAppendContent {
    return op.type === "AppendContent";
}

export function isTypeRemoveContent(op: Operation): op is OpRemoveContent {
    return op.type === "RemoveContent";
}

export function isTypeMoveContent(op: Operation): op is OpMoveContent {
    return op.type === "MoveContent";
}

export function isTypeSetContentName(op: Operation): op is OpSetContentName {
    return op.type === "SetContentName";
}

export function isTypeSetContentSize(op: Operation): op is OpSetContentSize {
    return op.type === "SetContentSize";
}

export function isTypeSetContentIsHidden(op: Operation): op is OpSetContentIsHidden {
    return op.type === "SetContentIsHidden";
}

export function isTypeUpdateCellContent(op: Operation): op is OpUpdateCellContent {
    return op.type === "UpdateCellContent";
}

export function isTypeResizeCell(op: Operation): op is OpResizeCell {
    return op.type === "ResizeCell";
}

export function isTypeAppendRole(op: Operation): op is OpAppendRole {
    return op.type === "AppendRole";
}

export function isTypeRemoveRole(op: Operation): op is OpRemoveRole {
    return op.type === "RemoveRole";
}

export function isTypeMoveRole(op: Operation): op is OpMoveRole {
    return op.type === "MoveRole";
}

export function isTypeSetRoleName(op: Operation): op is OpSetRoleName {
    return op.type === "SetRoleName";
}

export function isTypeSetRoleCellName(op: Operation): op is OpSetRoleCellName {
    return op.type === "SetRoleCellName";
}

export function isTypeSetShowPersona(op: Operation): op is OpSetShowPersona {
    return op.type === "SetShowPersona";
}

export function isTypeSetPersonaImage(op: Operation): op is OpSetPersonaImage {
    return op.type === "SetPersonaImage";
}

export function isTypeSetPersonaTagline(op: Operation): op is OpSetPersonaTagline {
    return op.type === "SetPersonaTagline";
}

export function isTypeSetPersonaSpecName(op: Operation): op is OpSetPersonaSpecName {
    return op.type === "SetPersonaSpecName";
}

export function isTypeSetPersonaSpecValue(op: Operation): op is OpSetPersonaSpecValue {
    return op.type === "SetPersonaSpecValue";
}

export function isTypeSetPersonaDescription(op: Operation): op is OpSetPersonaDescription {
    return op.type === "SetPersonaDescription";
}

export interface OpData {
}

interface OpDataUpdateJourneyMap extends OpData {
    journey_map: SerializableJourneyMap;

}

export class OpUpdateJourneyMap extends Operation {

    constructor(data: OpDataUpdateJourneyMap) {
        super("UpdateJourneyMap", data);
    }

    get JourneyMap(): SerializableJourneyMap {
        return (this.data as OpDataUpdateJourneyMap).journey_map;
    }

    static fromJSON(data: any) {
        return new OpUpdateJourneyMap({
            journey_map: converter(data.journey_map, "SerializableJourneyMap") as SerializableJourneyMap,
        });
    }
}

interface OpDataUpdateTitle extends OpData {
    title: string;

}

export class OpUpdateTitle extends Operation {

    constructor(data: OpDataUpdateTitle) {
        super("UpdateTitle", data);
    }

    get Title(): string {
        return (this.data as OpDataUpdateTitle).title;
    }

    static fromJSON(data: any) {
        return new OpUpdateTitle({
            title: converter(data.title, "string") as string,
        });
    }
}

interface OpDataUpdateBackground extends OpData {
    background_key: string;

}

export class OpUpdateBackground extends Operation {

    constructor(data: OpDataUpdateBackground) {
        super("UpdateBackground", data);
    }

    get BackgroundKey(): string {
        return (this.data as OpDataUpdateBackground).background_key;
    }

    static fromJSON(data: any) {
        return new OpUpdateBackground({
            background_key: converter(data.background_key, "string") as string,
        });
    }
}

interface OpDataUpdateColorScheme extends OpData {
    color_scheme_key: string;

}

export class OpUpdateColorScheme extends Operation {

    constructor(data: OpDataUpdateColorScheme) {
        super("UpdateColorScheme", data);
    }

    get ColorSchemeKey(): string {
        return (this.data as OpDataUpdateColorScheme).color_scheme_key;
    }

    static fromJSON(data: any) {
        return new OpUpdateColorScheme({
            color_scheme_key: converter(data.color_scheme_key, "string") as string,
        });
    }
}

interface OpDataAppendFunnel extends OpData {
    funnel: Funnel;
    position: number;

}

export class OpAppendFunnel extends Operation {

    constructor(data: OpDataAppendFunnel) {
        super("AppendFunnel", data);
    }

    get Funnel(): Funnel {
        return (this.data as OpDataAppendFunnel).funnel;
    }

    get Position(): number {
        return (this.data as OpDataAppendFunnel).position;
    }

    static fromJSON(data: any) {
        return new OpAppendFunnel({
            funnel: converter(data.funnel, "Funnel") as Funnel,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataRemoveFunnel extends OpData {
    funnel_key: FunnelKey;

}

export class OpRemoveFunnel extends Operation {

    constructor(data: OpDataRemoveFunnel) {
        super("RemoveFunnel", data);
    }

    get FunnelKey(): FunnelKey {
        return (this.data as OpDataRemoveFunnel).funnel_key;
    }

    static fromJSON(data: any) {
        return new OpRemoveFunnel({
            funnel_key: converter(data.funnel_key, "FunnelKey") as FunnelKey,
        });
    }
}

interface OpDataMoveFunnel extends OpData {
    funnel_key: FunnelKey;
    position: number;

}

export class OpMoveFunnel extends Operation {

    constructor(data: OpDataMoveFunnel) {
        super("MoveFunnel", data);
    }

    get FunnelKey(): FunnelKey {
        return (this.data as OpDataMoveFunnel).funnel_key;
    }

    get Position(): number {
        return (this.data as OpDataMoveFunnel).position;
    }

    static fromJSON(data: any) {
        return new OpMoveFunnel({
            funnel_key: converter(data.funnel_key, "FunnelKey") as FunnelKey,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataSetFunnelName extends OpData {
    funnel_key: FunnelKey;
    name: string;

}

export class OpSetFunnelName extends Operation {

    constructor(data: OpDataSetFunnelName) {
        super("SetFunnelName", data);
    }

    get FunnelKey(): FunnelKey {
        return (this.data as OpDataSetFunnelName).funnel_key;
    }

    get Name(): string {
        return (this.data as OpDataSetFunnelName).name;
    }

    static fromJSON(data: any) {
        return new OpSetFunnelName({
            funnel_key: converter(data.funnel_key, "FunnelKey") as FunnelKey,
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataSetFunnelSize extends OpData {
    funnel_key: FunnelKey;
    size: number;

}

export class OpSetFunnelSize extends Operation {

    constructor(data: OpDataSetFunnelSize) {
        super("SetFunnelSize", data);
    }

    get FunnelKey(): FunnelKey {
        return (this.data as OpDataSetFunnelSize).funnel_key;
    }

    get Size(): number {
        return (this.data as OpDataSetFunnelSize).size;
    }

    static fromJSON(data: any) {
        return new OpSetFunnelSize({
            funnel_key: converter(data.funnel_key, "FunnelKey") as FunnelKey,
            size: converter(data.size, "number") as number,
        });
    }
}

interface OpDataSetFunnelIsHidden extends OpData {
    funnel_keys: FunnelKey[];
    is_hidden: boolean;

}

export class OpSetFunnelIsHidden extends Operation {

    constructor(data: OpDataSetFunnelIsHidden) {
        super("SetFunnelIsHidden", data);
    }

    get FunnelKeys(): FunnelKey[] {
        return (this.data as OpDataSetFunnelIsHidden).funnel_keys;
    }

    get IsHidden(): boolean {
        return (this.data as OpDataSetFunnelIsHidden).is_hidden;
    }

    static fromJSON(data: any) {
        return new OpSetFunnelIsHidden({
            funnel_keys: converter(data.funnel_keys, "FunnelKey[]") as FunnelKey[],
            is_hidden: converter(data.is_hidden, "boolean") as boolean,
        });
    }
}

interface OpDataSetFunnelGroupName extends OpData {
    funnel_keys: FunnelKey[];
    name: string;

}

export class OpSetFunnelGroupName extends Operation {

    constructor(data: OpDataSetFunnelGroupName) {
        super("SetFunnelGroupName", data);
    }

    get FunnelKeys(): FunnelKey[] {
        return (this.data as OpDataSetFunnelGroupName).funnel_keys;
    }

    get Name(): string {
        return (this.data as OpDataSetFunnelGroupName).name;
    }

    static fromJSON(data: any) {
        return new OpSetFunnelGroupName({
            funnel_keys: converter(data.funnel_keys, "FunnelKey[]") as FunnelKey[],
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataAppendContent extends OpData {
    content_header: ContentHeader;
    position: number;

}

export class OpAppendContent extends Operation {

    constructor(data: OpDataAppendContent) {
        super("AppendContent", data);
    }

    get ContentHeader(): ContentHeader {
        return (this.data as OpDataAppendContent).content_header;
    }

    get Position(): number {
        return (this.data as OpDataAppendContent).position;
    }

    static fromJSON(data: any) {
        return new OpAppendContent({
            content_header: converter(data.content_header, "ContentHeader") as ContentHeader,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataRemoveContent extends OpData {
    content_key: ContentKey;

}

export class OpRemoveContent extends Operation {

    constructor(data: OpDataRemoveContent) {
        super("RemoveContent", data);
    }

    get ContentKey(): ContentKey {
        return (this.data as OpDataRemoveContent).content_key;
    }

    static fromJSON(data: any) {
        return new OpRemoveContent({
            content_key: converter(data.content_key, "ContentKey") as ContentKey,
        });
    }
}

interface OpDataMoveContent extends OpData {
    content_key: ContentKey;
    position: number;

}

export class OpMoveContent extends Operation {

    constructor(data: OpDataMoveContent) {
        super("MoveContent", data);
    }

    get ContentKey(): ContentKey {
        return (this.data as OpDataMoveContent).content_key;
    }

    get Position(): number {
        return (this.data as OpDataMoveContent).position;
    }

    static fromJSON(data: any) {
        return new OpMoveContent({
            content_key: converter(data.content_key, "ContentKey") as ContentKey,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataSetContentName extends OpData {
    content_key: ContentKey;
    name: string;

}

export class OpSetContentName extends Operation {

    constructor(data: OpDataSetContentName) {
        super("SetContentName", data);
    }

    get ContentKey(): ContentKey {
        return (this.data as OpDataSetContentName).content_key;
    }

    get Name(): string {
        return (this.data as OpDataSetContentName).name;
    }

    static fromJSON(data: any) {
        return new OpSetContentName({
            content_key: converter(data.content_key, "ContentKey") as ContentKey,
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataSetContentSize extends OpData {
    content_key: ContentKey;
    size: number;

}

export class OpSetContentSize extends Operation {

    constructor(data: OpDataSetContentSize) {
        super("SetContentSize", data);
    }

    get ContentKey(): ContentKey {
        return (this.data as OpDataSetContentSize).content_key;
    }

    get Size(): number {
        return (this.data as OpDataSetContentSize).size;
    }

    static fromJSON(data: any) {
        return new OpSetContentSize({
            content_key: converter(data.content_key, "ContentKey") as ContentKey,
            size: converter(data.size, "number") as number,
        });
    }
}

interface OpDataSetContentIsHidden extends OpData {
    content_keys: ContentKey[];
    is_hidden: boolean;

}

export class OpSetContentIsHidden extends Operation {

    constructor(data: OpDataSetContentIsHidden) {
        super("SetContentIsHidden", data);
    }

    get ContentKeys(): ContentKey[] {
        return (this.data as OpDataSetContentIsHidden).content_keys;
    }

    get IsHidden(): boolean {
        return (this.data as OpDataSetContentIsHidden).is_hidden;
    }

    static fromJSON(data: any) {
        return new OpSetContentIsHidden({
            content_keys: converter(data.content_keys, "ContentKey[]") as ContentKey[],
            is_hidden: converter(data.is_hidden, "boolean") as boolean,
        });
    }
}

interface OpDataUpdateCellContent extends OpData {
    cell_key: ContentKeyPair;
    cell_content: CellContent;
    width: number | null;
    height: number | null;

}

export class OpUpdateCellContent extends Operation {

    constructor(data: OpDataUpdateCellContent) {
        super("UpdateCellContent", data);
    }

    get CellKey(): ContentKeyPair {
        return (this.data as OpDataUpdateCellContent).cell_key;
    }

    get CellContent(): CellContent {
        return (this.data as OpDataUpdateCellContent).cell_content;
    }

    get Width(): number | null {
        return (this.data as OpDataUpdateCellContent).width;
    }

    get Height(): number | null {
        return (this.data as OpDataUpdateCellContent).height;
    }

    static fromJSON(data: any) {
        return new OpUpdateCellContent({
            cell_key: converter(data.cell_key, "ContentKeyPair") as ContentKeyPair,
            cell_content: converter(data.cell_content, "CellContent") as CellContent,
            width: converter(data.width, "number | null") as number | null,
            height: converter(data.height, "number | null") as number | null,
        });
    }
}

interface OpDataResizeCell extends OpData {
    cell_key: ContentKeyPair;
    width: number;
    height: number;

}

export class OpResizeCell extends Operation {

    constructor(data: OpDataResizeCell) {
        super("ResizeCell", data);
    }

    get CellKey(): ContentKeyPair {
        return (this.data as OpDataResizeCell).cell_key;
    }

    get Width(): number {
        return (this.data as OpDataResizeCell).width;
    }

    get Height(): number {
        return (this.data as OpDataResizeCell).height;
    }

    static fromJSON(data: any) {
        return new OpResizeCell({
            cell_key: converter(data.cell_key, "ContentKeyPair") as ContentKeyPair,
            width: converter(data.width, "number") as number,
            height: converter(data.height, "number") as number,
        });
    }
}

interface OpDataAppendRole extends OpData {
    role_header: RoleHeader;
    position: number;

}

export class OpAppendRole extends Operation {

    constructor(data: OpDataAppendRole) {
        super("AppendRole", data);
    }

    get RoleHeader(): RoleHeader {
        return (this.data as OpDataAppendRole).role_header;
    }

    get Position(): number {
        return (this.data as OpDataAppendRole).position;
    }

    static fromJSON(data: any) {
        return new OpAppendRole({
            role_header: converter(data.role_header, "RoleHeader") as RoleHeader,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataRemoveRole extends OpData {
    role_key: RoleKey;

}

export class OpRemoveRole extends Operation {

    constructor(data: OpDataRemoveRole) {
        super("RemoveRole", data);
    }

    get RoleKey(): RoleKey {
        return (this.data as OpDataRemoveRole).role_key;
    }

    static fromJSON(data: any) {
        return new OpRemoveRole({
            role_key: converter(data.role_key, "RoleKey") as RoleKey,
        });
    }
}

interface OpDataMoveRole extends OpData {
    role_key: RoleKey;
    position: number;

}

export class OpMoveRole extends Operation {

    constructor(data: OpDataMoveRole) {
        super("MoveRole", data);
    }

    get RoleKey(): RoleKey {
        return (this.data as OpDataMoveRole).role_key;
    }

    get Position(): number {
        return (this.data as OpDataMoveRole).position;
    }

    static fromJSON(data: any) {
        return new OpMoveRole({
            role_key: converter(data.role_key, "RoleKey") as RoleKey,
            position: converter(data.position, "number") as number,
        });
    }
}

interface OpDataSetRoleName extends OpData {
    role_key: RoleKey;
    name: string;

}

export class OpSetRoleName extends Operation {

    constructor(data: OpDataSetRoleName) {
        super("SetRoleName", data);
    }

    get RoleKey(): RoleKey {
        return (this.data as OpDataSetRoleName).role_key;
    }

    get Name(): string {
        return (this.data as OpDataSetRoleName).name;
    }

    static fromJSON(data: any) {
        return new OpSetRoleName({
            role_key: converter(data.role_key, "RoleKey") as RoleKey,
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataSetRoleCellName extends OpData {
    role_key: RoleKey;
    funnel_keys: FunnelKey[];
    name: string;

}

export class OpSetRoleCellName extends Operation {

    constructor(data: OpDataSetRoleCellName) {
        super("SetRoleCellName", data);
    }

    get RoleKey(): RoleKey {
        return (this.data as OpDataSetRoleCellName).role_key;
    }

    get FunnelKeys(): FunnelKey[] {
        return (this.data as OpDataSetRoleCellName).funnel_keys;
    }

    get Name(): string {
        return (this.data as OpDataSetRoleCellName).name;
    }

    static fromJSON(data: any) {
        return new OpSetRoleCellName({
            role_key: converter(data.role_key, "RoleKey") as RoleKey,
            funnel_keys: converter(data.funnel_keys, "FunnelKey[]") as FunnelKey[],
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataSetShowPersona extends OpData {
    show: boolean;

}

export class OpSetShowPersona extends Operation {

    constructor(data: OpDataSetShowPersona) {
        super("SetShowPersona", data);
    }

    get Show(): boolean {
        return (this.data as OpDataSetShowPersona).show;
    }

    static fromJSON(data: any) {
        return new OpSetShowPersona({
            show: converter(data.show, "boolean") as boolean,
        });
    }
}

interface OpDataSetPersonaImage extends OpData {
    persona_image_key: string;

}

export class OpSetPersonaImage extends Operation {

    constructor(data: OpDataSetPersonaImage) {
        super("SetPersonaImage", data);
    }

    get PersonaImageKey(): string {
        return (this.data as OpDataSetPersonaImage).persona_image_key;
    }

    static fromJSON(data: any) {
        return new OpSetPersonaImage({
            persona_image_key: converter(data.persona_image_key, "string") as string,
        });
    }
}

interface OpDataSetPersonaTagline extends OpData {
    tagline: string;

}

export class OpSetPersonaTagline extends Operation {

    constructor(data: OpDataSetPersonaTagline) {
        super("SetPersonaTagline", data);
    }

    get Tagline(): string {
        return (this.data as OpDataSetPersonaTagline).tagline;
    }

    static fromJSON(data: any) {
        return new OpSetPersonaTagline({
            tagline: converter(data.tagline, "string") as string,
        });
    }
}

interface OpDataSetPersonaSpecName extends OpData {
    index: number;
    name: string;

}

export class OpSetPersonaSpecName extends Operation {

    constructor(data: OpDataSetPersonaSpecName) {
        super("SetPersonaSpecName", data);
    }

    get Index(): number {
        return (this.data as OpDataSetPersonaSpecName).index;
    }

    get Name(): string {
        return (this.data as OpDataSetPersonaSpecName).name;
    }

    static fromJSON(data: any) {
        return new OpSetPersonaSpecName({
            index: converter(data.index, "number") as number,
            name: converter(data.name, "string") as string,
        });
    }
}

interface OpDataSetPersonaSpecValue extends OpData {
    index: number;
    value: string;

}

export class OpSetPersonaSpecValue extends Operation {

    constructor(data: OpDataSetPersonaSpecValue) {
        super("SetPersonaSpecValue", data);
    }

    get Index(): number {
        return (this.data as OpDataSetPersonaSpecValue).index;
    }

    get Value(): string {
        return (this.data as OpDataSetPersonaSpecValue).value;
    }

    static fromJSON(data: any) {
        return new OpSetPersonaSpecValue({
            index: converter(data.index, "number") as number,
            value: converter(data.value, "string") as string,
        });
    }
}

interface OpDataSetPersonaDescription extends OpData {
    description: string;

}

export class OpSetPersonaDescription extends Operation {

    constructor(data: OpDataSetPersonaDescription) {
        super("SetPersonaDescription", data);
    }

    get Description(): string {
        return (this.data as OpDataSetPersonaDescription).description;
    }

    static fromJSON(data: any) {
        return new OpSetPersonaDescription({
            description: converter(data.description, "string") as string,
        });
    }
}

